import type { PdfComponent } from '../../TermsAndConditionsRender/components/typed';

export const SECTION19: PdfComponent = {
  type: 'section',
  id: 's19',
  title: '19. Exclusivity',
  content: [
    {
      type: 'bulletList',
      id: 's19bullets',
      bulletType: 'number',
      content: [
        {
          copy: 'For the term of this Agreement, the Subscriber shall not:',
          sublist: {
            bulletType: 'alpha',
            content: [
              {
                copy: 'enter into any other similar agreement in relation to credit facilities with a competitor of Kanda without the prior written consent of Kanda; and',
              },
              {
                copy: 'appoint a provider of personal loans during the duration of this Agreement in addition to the lenders introduced by Kanda.',
              },
            ],
          },
        },
      ],
      prefix: '19',
    },
  ],
};
